import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "../model/requestUtils";
import { ENDPOINTS, AUTH_QUERY_CACHE } from "../model/authEndpoints";
import type { AskPasswordForm, ResetPasswordForm } from "../model/type";
import type { ApiError } from "../model/shared";

export const useAskPassword = () =>
  useMutation<AskPasswordForm, ApiError, { data: AskPasswordForm }>({
    mutationFn: async ({ data }) => {
      const response = await apiClient.post<AskPasswordForm>(
        ENDPOINTS.askPassword,
        data,
      );
      return response.data;
    },
  });

export const useValidateResetPasswordLink = (token?: string) =>
  useQuery<unknown, ApiError>({
    queryKey: [AUTH_QUERY_CACHE.RESET_PASSWORD_LINK],
    queryFn: async () => {
      if (!token) throw new Error("Token manquant");
      const response = await apiClient.get(
        ENDPOINTS.validateResetPasswordLink(token),
      );
      return response.data;
    },
    enabled: !!token,
  });

export const useResetPassword = () =>
  useMutation<
    ResetPasswordForm,
    ApiError,
    { data: ResetPasswordForm & { token: string } }
  >({
    mutationFn: async ({ data }) => {
      const response = await apiClient.post<ResetPasswordForm>(
        ENDPOINTS.resetPassword,
        data,
      );
      return response.data;
    },
  });
